<template>
  <div
    id="bg-style"
    :style="getBgStyle"
  >
    <login
      v-if="showLoginForm"
      :site-id="scannedCode"
      @closed="showLoginForm = false"
      @login-completed="loadOnMount"
    />
    <check-in-type-selection
      v-if="showCheckInTypes"
      :scanned-code="scannedCode"
      @closed="showCheckInTypes = false"
    />
    <qr-code-scanner
      v-if="showQrCodeScanner"
      @closed="showQrCodeScanner = false"
      @qr-code-scanned="toProcessSteps"
    />
    <p class="hello-style">
      Hello <font v-if="!isUserExist">
        Again!
      </font><font
        v-if="isUserExist"
        class="user-name"
      >
        {{ userName }}
      </font>
    </p><br><span class="welcome-style">Welcome back!</span>
    <v-btn
      v-if="isUserExist"
      class="check-in"
      color="#37474F"
      outlined
      @click="scanQrCode()"
    >
      <v-icon left>
        mdi-account-check-outline
      </v-icon>
      {{ processButton }}
    </v-btn>
    <div v-if="!isUserExist">
      <v-btn
        class="check-in"
        color="#37474F"
        outlined
        @click="signInClicked()"
      >
        <v-icon left>
          mdi-account-check-outline
        </v-icon>
        Sign-In
      </v-btn>
      <font class="register-style">
        Not registered yet ?<span
          style="color:#FF3700;"
          @click="registerClicked()"
        > Sign Up </span>now.
      </font>
    </div>
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
    >
    <div class="icons">
      <a
        href="https://www.facebook.com/dbsystems.com.au"
        class="fa fa-facebook"
      />
      <a
        href="https://www.youtube.com/channel/UCEirQfvWgNoMkTwB_L_Wb0Q"
        class="fa fa-youtube"
      />
      <a
        href="https://www.linkedin.com/company/dbsystems/"
        class="fa fa-linkedin"
      />
      <a
        href="https://www.instagram.com/dbsystems.com.au/"
        class="fa fa-instagram"
      />
    </div>
    <p class="p-style">
      Don't have an account ?<span
        class="span-style"
        @click="registerClicked()"
      > Register </span>here.
    </p>
    <centre-spinner
      :loading="loading"
    />
  </div>
</template>

<script>
import Login from './Login.vue';
import CheckInTypeSelection from './process/Checkin/CheckInTypeSelection.vue';
import QrCodeScanner from './process/QrCodeScanner.vue';
import axios from '@/app-axios';
import Constants from 'src/constants';
import spinner from 'src/views/components/SpinnerCentre';

export default {
  name: 'Home',
  components: {
    login: Login,
    'check-in-type-selection': CheckInTypeSelection,
    'qr-code-scanner': QrCodeScanner,
    'centre-spinner': spinner,
  },
  data: () => ({
    homeBgImg: require('@/assets/img/homeBg.png'),
    showLoginForm: false,
    showCheckInTypes: false,
    showQrCodeScanner: false,
    scannedCode: null,
    isUserExist: false,
    isUserAlreadyCheckedIn: false,
    loading: false,
    isSignInClicked: false,
    userName: '',
  }),
  computed: {
    getBgStyle () {
      return `background-image:url(${this.homeBgImg})`;
    },
    processButton () {
      if (this.isUserAlreadyCheckedIn === true) {
        return 'Check-Out';
      }
      return 'Check-In';
    },
    activeCheckInDetails () {
      return this.$store.getters['swiftuser/getActiveCheckInDetails'];
    },
  },
  async mounted () {
    this.loading = true;
    this.checkQrScanTime();
    await this.loadOnMount();
    this.loading = false;
  },
  methods: {
    checkQrScanTime () {
      const scannedTime = localStorage.getItem('scannedTime');
      if (scannedTime === null) {
        return;
      }
      const currentTime = new Date().getTime();
      if ((currentTime - scannedTime) >= 300000) {
        localStorage.removeItem('siteId');
        localStorage.removeItem('scannedTime');
      }
    },
    async loadOnMount () {
      this.$store.dispatch('swiftuser/updateWorkTimer');
      this.$store.dispatch('swiftuser/clearContractorDocVerifyStatus');
      this.$store.dispatch('swiftuser/clearScannedLocationName');
      this.$store.dispatch('swiftuser/clearManualCheckoutReason');
      this.checkUserExist();
      const userInfo = localStorage.getItem('user');
      if (userInfo === null) {
        return;
      }
      await axios.get('api/devices/me')
      .then(response => {
        const userData = JSON.parse(userInfo);
        this.$store.commit('setUserData', userData);
        this.checkUserExist();
        this.fetchActiveCheckInDetails();
        this.getOrganizationSettings();
      })
      .catch(errors => {
        axios.post('api/devices/logout').then(response => {
          this.$store.dispatch('logout');
          this.checkUserExist();
        });
        this.$store.dispatch('logout');
        this.checkUserExist();
      });
    },
    checkUserExist () {
      var userExist = localStorage.getItem('user');
      var checkInTime = localStorage.getItem('checkInTime');
      if (userExist !== null) {
        this.isUserExist = true;
        const userDetails = JSON.parse(userExist);
        this.userName = userDetails.service_provider.first_name;
      } else {
        this.isUserExist = false;
      }
      if (this.isUserExist === true && checkInTime !== null) {
        this.isUserAlreadyCheckedIn = true;
      } else {
        this.isUserAlreadyCheckedIn = false;
      }
    },
    async fetchActiveCheckInDetails () {
      this.loading = true;
      const checkInId = localStorage.getItem('checkIn');
      const checkInTime = localStorage.getItem('checkInTime');
      if (checkInId === null || checkInTime === null) {
        await this.$store.dispatch('swiftuser/fetchUsersCurrentCheckInDetails').then(response => {
          if (Object.keys(this.activeCheckInDetails).length > 0) {
            const checkInId = this.activeCheckInDetails.id;
            const checkInTime = +new Date(this.activeCheckInDetails.checkin_time);
            localStorage.setItem('checkIn', checkInId);
            localStorage.setItem('checkInTime', checkInTime);
            this.checkUserExist();
            this.$store.dispatch('swiftuser/updateWorkTimer');
            this.loading = false;
            return;
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
        return;
      }
      await this.$store.dispatch('swiftuser/fetchActiveCheckInDetails', {
        checkInId: checkInId,
      }).then(response => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    registerClicked () {
      this.checkQrScanTime();
      this.isSignInClicked = false;
      if (this.isUserExist === true) {
        this.$store.dispatch('alert/onAlert', {
          message: 'You are already registered.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      const siteId = localStorage.getItem('siteId');
      if (siteId !== null) {
        this.toProcessSteps(siteId);
        return;
      }
      this.showQrCodeScanner = true;
    },
    signInClicked () {
      this.checkQrScanTime();
      this.isSignInClicked = true;
      const siteId = localStorage.getItem('siteId');
      if (siteId !== null) {
        this.toProcessSteps(siteId);
        return;
      }
      this.showQrCodeScanner = true;
    },
    scanQrCode () {
      this.checkQrScanTime();
      const siteId = localStorage.getItem('siteId');
      if (siteId !== null) {
        this.toProcessSteps(siteId);
        return;
      }
      this.showQrCodeScanner = true;
    },
    toProcessSteps (val) {
      if (this.isUserExist === false && this.isSignInClicked === false) {
        this.$router.push(`${val}/register`);
      } else if (this.isUserExist === false && this.isSignInClicked === true) {
        this.scannedCode = val;
        this.showLoginForm = true;
      } else if (this.isUserAlreadyCheckedIn === false) {
        this.scannedCode = val;
        this.showCheckInTypes = true;
      } else {
        const currentCheckInType = this.activeCheckInDetails.type;
        this.$store.dispatch('swiftuser/saveCheckoutType', 'qrScan');
        this.$router.push(`${val}/check-out/${currentCheckInType}`);
      }
    },
    async getOrganizationSettings () {
      await this.$store.dispatch('userprofile/fetchOrganizationSettings');
    },
  },
};
</script>

<style scoped>
#bg-style {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding-bottom: 100%;
  margin-bottom: 100%;
  width: 100%;
  text-align:center;
}
.check-in {
  bottom: 20%;
  position: absolute;
  margin-left:-50px;
  left:25%;
  width: 75%;
  font-weight: bold;
}
.check-in.btn:hover {
  color: #37474F;
}
.hello-style {
  color: #37474F;
  font-weight:900;
  font-size: 25px;
  font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  bottom: 32%;
  position: absolute;
  left: 20px;
}
.welcome-style {
  color: #FF3700;
  font-weight:900;
  font-size: 20px;
  font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  bottom: 30%;
  position: absolute;
  left: 20px;
}
.p-style {
  bottom: 0%;
  position: absolute;
  margin-left:-50px;
  left:25%;
  font-weight: bold;
  color: #37474F;
  text-align: center;
  font-family: 'Times New Roman', Times, serif;
}
.span-style {
  font-family: 'Times New Roman', Times, serif;
  color: #FF3700;
  font-weight: bold;
}
.icons {
  position:absolute;
  bottom:3%;
  right:10%;
  left:50%;
  margin-left:-150px;
}
.fa {
border: 1px solid #DDDDDD;
border-radius: 50%;
display: inline-flex;
justify-content: center;
align-items: center;
margin: 0 5px;
height: 40px;
width: 40px;
bottom: 20%;
margin: 40px 0;
margin-right: 15px;
}
.fa:hover {
  opacity: 0.7;
}
.fa-facebook {
  background: #3B5998;
  color: white;
}
.fa-linkedin {
  background: #3B5998;
  color: white;
}
.fa-instagram {
  background: radial-gradient(circle at 33% 100%, #fed373 4%, #f15245 30%, #d92e7f 62%, #9b36b7 85%, #515ecf);
  color: white;
}
.fa-youtube {
  background: #bb0000;
  color: white;
}
.register-style {
  bottom: 17%;
  position: absolute;
  margin-left:-50px;
  left:25%;
  color: #37474F;
  text-align: center;
  font-family: 'Times New Roman', Times, serif;
  font-size: 15px;
}
.user-name {
  text-transform: capitalize;
}
</style>
